import {noop} from '@benchling/js-utils';

import {makeReactContext} from 'lib/makeReactContext';

import {ProcedureValidationError} from './ProcedureValidationTypes';

export interface ProcedureValidationContextValue {
  procedureValidationErrors: Array<ProcedureValidationError>;
  anyTabValidationErrors: boolean;
  setAnyTabValidationErrors: (anyErrors: boolean) => void;
}

export const ProcedureValidationContext = makeReactContext<ProcedureValidationContextValue>(
  () => ({
    procedureValidationErrors: [],
    anyTabValidationErrors: false,
    setAnyTabValidationErrors: noop,
  }),
  'ProcedureValidationContext'
);
